import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const slide = keyframes`
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(-100%);
    }
`;

export const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: 500px;
  width: 100%;
`;

export const StyledSvg = styled.svg`
  height: 100%;
  width: 100%;
`;

export const StyledWheel = styled.g`
  transform-origin: 50% 50%;
  transform-box: fill-box;
  animation: ${rotate} 1s linear infinite;
`;

export const StyledRoad = styled.polygon`
  animation: ${slide} 1s linear infinite;
`;
